<template>
	<div class="CaretRight svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1697525695377" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8524" :width="size" :height="size">
			<path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z" fill="#333333" p-id="8525"></path>
		</svg>
	</div>
</template>
<script setup name="CaretRight">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 16
		}
	})
</script>
<style scoped lang="less">
	.CaretRight,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
